<template>
    <div class="data-item">
        <span class="data-item__value">{{ value }}</span>
        <span class="data-item__label">{{ label }}</span>
    </div>
</template>

<script >
const __sfc_main = {};
__sfc_main.props = {
  label: {
    type: String,
    default: ''
  },
  value: {
    type: [String, Number],
    default: ''
  }
};
export default __sfc_main;
</script>

<style lang="less" scoped>
.data-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0.05rem;

    &__value {
        font-size: 0.32rem;
        font-weight: 600;
        color: #333;
        line-height: 0.42rem;
    }

    &__label {
        font-size: 0.22rem;
        font-weight: 400;
        color: #999;
        line-height: 0.3rem;
    }
}
</style>
